var _a;
/* Config file for flexible food bundle constants. Keep in sync with _v9_config.py */
import { PET_TYPE } from './enums';
var RECIPE_TO_SINGLE_BUNDLE_SUBTOTAL = {
    beef: 55.02,
    chicken: 45.99,
    lamb: 61.88,
    pork: 49.0,
    turkey: 49.0,
    turkey_chicken: 47.53,
};
var DEFAULT_NUM_BUNDLES_FOR_FLEXIBLE_FOOD_SIGNUP = 2;
var MAX_NUM_RECIPES_FOR_FLEXIBLE_FOOD_SIGNUP = 4;
var NUM_MEAL_PACKS_PER_BUNDLE = 7;
/* Keep mapping up-to-date with pet_utils.py DEFAULT_FIXED_SKU_GRAMS_BY_PET. */
var DEFAULT_FIXED_SKU_GRAMS_BY_PET = (_a = {},
    _a[PET_TYPE.CAT] = 110,
    _a[PET_TYPE.DOG] = 400,
    _a);
var DEFAULT_NUM_PACKS_OPTIONS_FOR_FLEXIBLE = [7, 14, 21, 28, 35, 42, 49, 56];
export { DEFAULT_FIXED_SKU_GRAMS_BY_PET, DEFAULT_NUM_BUNDLES_FOR_FLEXIBLE_FOOD_SIGNUP, DEFAULT_NUM_PACKS_OPTIONS_FOR_FLEXIBLE, MAX_NUM_RECIPES_FOR_FLEXIBLE_FOOD_SIGNUP, NUM_MEAL_PACKS_PER_BUNDLE, RECIPE_TO_SINGLE_BUNDLE_SUBTOTAL, };
